import { createListenerMiddleware } from '@reduxjs/toolkit';
import { natalieEventApi } from 'natalie/api/natalieEventApi';
import { RootState } from 'store';

import { natalieActions } from './natalie.actions';
import {
  beforeJoinContinueButtonClickedEffect,
  copyAccountlessLinkButtonClickedEffect,
  copyAccountlessTestLinkButtonClickedEffect,
  copyPublicLinkButtonClickedEffect,
  copyPublicTestLinkButtonClickedEffect,
  joinButtonClickedEffect,
  natalieIssueReportedEffect,
  registerToNatalieEventFailedEffect,
  registerToNatalieEventSuccessEffect,
  requestNatalieCreateEventFailedEffect,
  requestNatalieCreateEventSuccessEffect,
  startChattingButtonClickedEffect,
} from './natalie.effects';

export const natalieListener = createListenerMiddleware<RootState>();

natalieListener.startListening({
  actionCreator: natalieActions.beforeJoinPage.continueButton.clicked,
  effect: beforeJoinContinueButtonClickedEffect,
});

natalieListener.startListening({
  matcher: natalieEventApi.endpoints.registerToNatalieEvent.matchFulfilled,
  effect: registerToNatalieEventSuccessEffect,
});

natalieListener.startListening({
  matcher: natalieEventApi.endpoints.registerToNatalieEvent.matchRejected,
  effect: registerToNatalieEventFailedEffect,
});

natalieListener.startListening({
  matcher: natalieEventApi.endpoints.requestNatalieCreateEvent.matchFulfilled,
  effect: requestNatalieCreateEventSuccessEffect,
});

natalieListener.startListening({
  matcher: natalieEventApi.endpoints.requestNatalieCreateEvent.matchRejected,
  effect: requestNatalieCreateEventFailedEffect,
});

natalieListener.startListening({
  actionCreator: natalieActions.detailsPage.startChattingButton.clicked,
  effect: startChattingButtonClickedEffect,
});

natalieListener.startListening({
  actionCreator: natalieActions.joinPage.joinButton.clicked,
  effect: joinButtonClickedEffect,
});

natalieListener.startListening({
  actionCreator: natalieActions.list.moreActions.copyPublicLinkButtonClicked,
  effect: copyPublicLinkButtonClickedEffect,
});

natalieListener.startListening({
  actionCreator: natalieActions.list.moreActions.copyPublicTestLinkButtonClicked,
  effect: copyPublicTestLinkButtonClickedEffect,
});

natalieListener.startListening({
  actionCreator: natalieActions.list.moreActions.copyAccountlessLinkButtonClicked,
  effect: copyAccountlessLinkButtonClickedEffect,
});

natalieListener.startListening({
  actionCreator: natalieActions.list.moreActions.copyAccountlessTestLinkButtonClicked,
  effect: copyAccountlessTestLinkButtonClickedEffect,
});

natalieListener.startListening({
  actionCreator: natalieActions.room.header.issueReported,
  effect: natalieIssueReportedEffect,
});
